import React from "react";
import { Container, Sidebar } from "semantic-ui-react";
import { MediaContextProvider } from "utils/media";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";

interface MainLayoutProps {
  activePage?: string;
  container?: boolean;
}

export const MainLayout: React.FC<MainLayoutProps> = ({
  children,
  activePage = "",
  container = true,
}) => {
  return (
    <MediaContextProvider>
      <Navbar activePage={activePage} />
      <Sidebar.Pusher
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {container ? (
          <Container
            as="main"
            style={{
              margin: "7rem auto",
              flex: "1 0 auto",
            }}
          >
            {children}
          </Container>
        ) : (
          <main
            style={{
              margin: "7rem auto",
              flex: "1 0 auto",
            }}
          >
            {children}
          </main>
        )}

        <Footer />
      </Sidebar.Pusher>
    </MediaContextProvider>
  );
};

export default MainLayout;
